import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";

import { LktIconComponent } from "../icon/icon.component";

/**
 * Estado vazio da lista de notificações (DEV-872, CA 02) — e, desde o fix round final (achado 2,
 * Important), também a casca do estado de ERRO de carga: mesmo par título+descrição, cópia
 * diferente, com um botão de ação opcional.
 *
 * Dois textos, ação opcional: quem escolhe a copy é o container, porque ela depende do filtro ativo
 * ("Nenhuma notificação ainda" x "Tudo lido por aqui") ou do motivo do erro. `actionLabel` ausente
 * = sem botão, o caso vazio real; presente = oferece "tentar de novo" no caso de erro. Nunca os
 * dois brotam do mesmo `status`: quem decide qual copy (e se há ação) é sempre o consumidor.
 *
 * Reusa o próprio `bell` a 34px com traço apagado — não existe sino cortado na
 * linguagem visual, e inventar um traço novo aqui seria divergir do design.
 */
@Component({
  selector: "lkt-notification-empty",
  standalone: true,
  imports: [LktIconComponent],
  templateUrl: "./notification-empty.component.html",
  styleUrl: "./notification-empty.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LktNotificationEmptyComponent {
  public readonly title = input.required<string>();
  public readonly description = input.required<string>();
  public readonly dataCy = input<string>("");
  /** Rótulo do botão de ação (ex.: "Tentar novamente"). Ausente = sem botão. */
  public readonly actionLabel = input<string>("");

  public readonly action = output<void>();

  /** Sem `dataCy` do consumidor não emite atributo — nada de `"-icon"` órfão. */
  public readonly iconDataCy = computed<string | undefined>(() =>
    this.dataCy() ? `${this.dataCy()}-icon` : undefined
  );

  /** Mesmo motivo do ícone: sem `dataCy` do consumidor, nada de `"-retry-button"` órfão. */
  public readonly actionDataCy = computed<string | undefined>(() =>
    this.dataCy() ? `${this.dataCy()}-retry-button` : undefined
  );

  public onAction(): void {
    this.action.emit();
  }
}
